import React from 'react';
import {
  FormControl,
  FormLabel,
  Box,
  ToggleButton,
  ToggleButtonGroup,
  TextField,
  FormGroup
} from '@mui/material';
import {Controller, useFormContext} from 'react-hook-form';

interface datefield {
  field: any;
  name: string;
}

const NPSRatingscale: React.FC<datefield> = ({field, name}) => {
  const {control} = useFormContext();

  const getColor = (index: number) => {
    if (index <= 6) return '#f44336'; // Red
    if (index === 7 || index === 8) return '#ffeb3b'; // Yellow
    return '#4caf50'; // Green
  };

  return (
    <>
      <FormControl component="fieldset" margin="normal">
        <FormLabel component="legend">Answer Score</FormLabel>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap'
          }}>
          <ToggleButtonGroup
            exclusive
            aria-label="answer score"
            fullWidth
            disabled
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap'
            }}>
            {[...Array(11)].map((_, index) => (
              <ToggleButton
                key={index}
                value={index}
                sx={{
                  flex: '1 0 9%',
                  margin: '2px !important',
                  backgroundColor: getColor(index),
                  maxWidth: '45px',
                  color: 'black !important'
                }}>
                {index}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Box>
        <Controller
          name={name || ''}
          control={control}
          render={({field, fieldState: {error}}) => (
            <FormGroup>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  mt: 1
                }}>
                <TextField
                  variant="outlined"
                  value={field.value.likely}
                  onChange={e => {
                    field.onChange({...field.value, likely: e.target.value});
                  }}
                  error={!!error}
                  helperText={
                    error && error?.message
                      ? error?.message
                      : (error as any)?.likely?.message
                  }
                />
                <TextField
                  variant="outlined"
                  value={field.value.notlikely}
                  onChange={e =>
                    field.onChange({
                      ...field.value,
                      notlikely: e.target.value
                    })
                  }
                  error={!!error}
                  helperText={
                    error && error?.message
                      ? error?.message
                      : (error as any)?.notlikely?.message
                  }
                />
              </Box>
            </FormGroup>
          )}
        />
      </FormControl>
    </>
  );
};

export default NPSRatingscale;
